import { useMutation } from '@tanstack/react-query';
import { verifyOtpApi, resendOtpApi } from '../api/auth';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export const useVerifyOtp = () => {
  const { onOtpSuccess, pendingData } = useAuth();
  const { error: toastError } = useToast();

  return useMutation({
    mutationFn: (otp) =>
      verifyOtpApi({ email: pendingData?.email, otp }),
    onSuccess: (data) => {
      onOtpSuccess(data);
    },
    onError: (err) => {
      toastError(err?.message || 'Incorrect OTP. Please try again.');
    },
  });
};

export const useResendOtp = () => {
  const { pendingData } = useAuth();
  const { error: toastError, success: toastSuccess } = useToast();

  return useMutation({
    mutationFn: () =>
      resendOtpApi({ email: pendingData?.email }),
    onSuccess: () => {
      toastSuccess('OTP resent to your email!');
    },
    onError: (err) => {
      toastError(err?.message || 'Failed to resend OTP. Please try again.');
    },
  });
};
